import React from 'react';
import  logo_icon  from '../../assets/images/mine/logo-icon.png'
import { useLocation, useNavigate } from 'react-router-dom';
import Profile from './Profile';
import { useDispatch, useSelector } from 'react-redux';


function Header() {
  const { isAuthenticated } = useSelector(state => state.userState)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const handleSignin = () => {
    navigate('/', { replace: true, state:{ from: location } })
  }
  return (
    <header class="navbar-light">
          <nav class="navbar navbar-expand-xl">
            <div class="container d-flex align-items-center">
            {/* Logo START */}
            <div onClick={()=>navigate('/')} className='navbar-logo'>
              <img src={logo_icon} alt="logo"/>
              <span>الربان</span>
            </div>
            {/* Logo END */}



            {/* Main navbar END */}
            {/* <!-- Header right side START --> */}
				<div class="d-flex justify-content-end pe-0">
					<ul class="nav flex-row align-items-center list-unstyled ms-xl-auto">

		
	
						{/* <!-- Sign In button --> */}
						<li class="nav-item ms-2">
            {isAuthenticated ?
              <Profile/> :
              <button onClick={handleSignin} class="btn btn-sm btn-dark mb-0">تسجيل الدخول</button>
            }
						</li>
					</ul>
				</div>
				{/* <!-- Header right side END --> */}

          

            </div>
          </nav>
        </header>
  )
}

export default Header